export const updateDatiRipartizionePremioFondi = (unDato, codiceFondo, nomeFondo, unActionType) => {
  return {
    type: unActionType,
    unDato,
    codiceFondo,
    nomeFondo,
  }
};